import { IVideoLoader } from "../helpers/video";

interface IAutoplayVideoInput {
    videoContainer: HTMLElement
    videoLoader: IVideoLoader,
    autoPlayFailCallback?: Function
}

const SHOW_CLASS = 'show';

/**
 * A class that handles the play/pause button of an autoplaying background video
 */
export class AutoplayVideo {
    private playBtn: HTMLElement;
    private pauseBtn: HTMLElement;

    constructor({
        videoContainer,
        videoLoader,
        autoPlayFailCallback
    }: IAutoplayVideoInput) {
        this.playBtn = videoContainer.querySelector('[data-play-btn]') as HTMLElement;
        this.pauseBtn = videoContainer.querySelector('[data-pause-btn]') as HTMLElement;
        this.onPlay = this.onPlay.bind(this);
        this.onPause = this.onPause.bind(this);

        if (this.playBtn && this.pauseBtn) {
            videoLoader.setOnPlay(this.onPlay);
            videoLoader.setOnPause(this.onPause);
            this.playBtn.addEventListener('click', () => {
                videoLoader.play()
            });
            this.pauseBtn.addEventListener('click', () => {
                videoLoader.pause();
            });
        }

        videoLoader.triggerAutoPlay(autoPlayFailCallback);
    }

    onPlay() {
        this.playBtn?.classList.remove(SHOW_CLASS);
        this.pauseBtn?.classList.add(SHOW_CLASS);
    }

    onPause() {
        this.pauseBtn?.classList.remove(SHOW_CLASS);
        this.playBtn?.classList.add(SHOW_CLASS);
    }
}
